var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrows(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3.4375C12 3.76562 11.7656 4 11.4375 4H3V5.125C3 5.64062 2.41406 5.875 2.0625 5.52343L0.1875 3.64843C-0.046875 3.4375 -0.046875 3.08593 0.1875 2.875L2.0625 0.999997C2.41406 0.624997 3 0.882809 3 1.375V2.5H11.4375C11.7656 2.5 12 2.75781 12 3.0625V3.4375ZM0.5625 7H9V5.875C9 5.38281 9.60938 5.125 9.96094 5.5L11.8359 7.375C12.0703 7.58593 12.0703 7.9375 11.8359 8.14843L9.96094 10.0234C9.60938 10.375 9 10.1406 9 9.625V8.5H0.5625C0.257812 8.5 0 8.26562 0 7.9375V7.5625C0 7.25781 0.257812 7 0.5625 7Z",
    fill: "#444444"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrows);
export default __webpack_public_path__ + "static/media/arrows.2df034c8.svg";
export { ForwardRef as ReactComponent };